import type { RouteObject } from "react-router"

export const profileRoutes: RouteObject[] = [
  {
    path: "profile",
    lazy: () => import("./profile-page").then((m) => ({ Component: m.ProfilePage })),
  },
]
